import React from "react";
import {Link} from "react-router-dom";
import {Routes_path} from "../../routerApp";
import {PermissionTypes} from "../../authentication/permissionsGroups";
import Button from "@mui/material/Button";
import AutorizzazioneGruppi from "../../authentication/AutorizzazioneGruppi";


interface HomeMenuButtonProps {
    nome: string;
    gruppiAutorizzati: PermissionTypes[];
    path: Routes_path;
    Icon: any;
}

const HomeMenuButton = ({
                            nome,
                            gruppiAutorizzati,
                            path,
                            Icon,
                        }: HomeMenuButtonProps) => {
    return (
        <AutorizzazioneGruppi gruppiAutorizzati={gruppiAutorizzati}>
            <Button
                sx={{
                    background: "linear-gradient(40deg, #03b0e2 50%, #03b0e255 100%)",
                    "&:hover": {
                        background:
                            "linear-gradient(25deg, #03b0e2ee 50%, #03b0e2aa 100%)",
                        color: "#f8ec06dd",
                    },

                    color: "#fff",
                    width: "100%",
                    minHeight: 90,
                    elevation: 3,
                    alignContent: "center",
                    fontSize: {lg: "1vw", md: 20, sm: 14, xs: 14},
                }}
                // startIcon={<Icon sx={{ height: 50, mx: 3 }} />}
                variant="contained"
                component={Link}
                to={path}
            >
                <Icon
                    sx={{
                        fontSize: {lg: "3vw", md: 50, sm: 25, xs: 22},
                        mr: {md: 3, sm: 2, xs: 2},
                    }}
                />
                {nome}
            </Button>
        </AutorizzazioneGruppi>
    );
};

export default HomeMenuButton;
